var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
var RegisterComponent = /** @class */ (function () {
    function RegisterComponent(util, apiService) {
        this.util = util;
        this.apiService = apiService;
        this.obj_data_all = [];
        this.obj_data = {};
        this.obj_memberkey_all = [];
    }
    RegisterComponent.prototype.ngOnInit = function () {
        var that = this;
        var table = $('#tData').DataTable({
            "aaSorting": [],
            'columnDefs': [
                {
                    'targets': 9,
                    'searchable': false,
                    'orderable': false,
                    "className": "text-center",
                    'render': function (data, type, full, meta) {
                        return '<i name="delete" class="fas fa-trash" style="color: red; cursor: pointer " role="' + data + '"></i>';
                    },
                },
                {
                    'targets': [0, 1, 2, 3, 4, 5, 6, 7, 8],
                    'width': 100
                }
            ],
            'scrollX': true,
        });
        $('#tData tbody').on('click', 'tr', function () {
            that.InitEdit(table.row(this).data()[0]);
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            }
            else {
                table.$('tr.selected').removeClass('selected');
                $(this).addClass('selected');
            }
        });
        $('#tData tbody').on('click', 'i', function () {
            var r = confirm("ยืนยันลบสมาชิก : " + $(this).attr('role'));
            if (r == true) {
                that.DeleteMember($(this).attr('role'));
            }
        });
        $('#tDlgData').dataTable({
            'columnDefs': [
                {
                    'targets': [0, 1, 2],
                    "className": "text-center"
                }, {
                    'targets': 0,
                    'searchable': false,
                    'orderable': false,
                    "className": "text-center",
                    'render': function (data, type, full, meta) {
                        return '<input type="texebox" style="text-align:center" name="memberkey" value="' + data + '">';
                    }
                },
                {
                    'targets': 1,
                    'searchable': false,
                    'orderable': false,
                    "className": "text-center",
                    'render': function (data, type, full, meta) {
                        return '<input type="texebox" style="text-align:center" name="expiredate" maxlength="10" data-provide="datepicker"   value="' + data + '">';
                    }
                },
                {
                    'targets': 2,
                    'searchable': false,
                    'orderable': false,
                    "className": "text-center",
                    'render': function (data, type, full, meta) {
                        return '<i name="delete" class="fas fa-trash" style="color: red; cursor: pointer " role="' + data + '"></i>';
                    }
                }
            ]
        });
        this.InitDropDown();
    };
    RegisterComponent.prototype.BeforeSearch = function () {
        this.util.ShowWaiting(true);
        this.Search();
    };
    RegisterComponent.prototype.Search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var table, that, data, res, i, status, sex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ClearDlg();
                        this.obj_data_all = [];
                        this.obj_data = {};
                        table = $('#tData').DataTable();
                        table.clear().draw();
                        that = this;
                        data = {};
                        data["MEMBER_NO"] = $('#txtID').val();
                        data["NAME"] = $('#txtName').val();
                        data["MEMBER_TYPE"] = $('#ddlMemberType').val();
                        data["STATUS"] = $('#ddlStatus').val();
                        return [4 /*yield*/, this.apiService.post('member', 'getmember', data)];
                    case 1:
                        res = _a.sent();
                        console.log(res);
                        this.util.ShowWaiting(false);
                        if (res.isSuccess) {
                            if (res.responseData != null) {
                                if (res.responseData.length > 0) {
                                    this.obj_data_all = res.responseData;
                                    for (i = 0; i < res.responseData.length; i++) {
                                        status = '';
                                        if (res.responseData[i].status == 1) {
                                            status = "ใช้งาน";
                                        }
                                        else {
                                            status = "ไม่ใช้งาน";
                                        }
                                        sex = res.responseData[i].sex;
                                        if (this.util.GetLanguage() == 'th-TH') {
                                            if (sex == 'M') {
                                                sex = "ชาย";
                                            }
                                            if (sex == 'F') {
                                                sex = "หญิง";
                                            }
                                        }
                                        else {
                                            if (sex == 'M') {
                                                sex = "Male";
                                            }
                                            else {
                                                sex = "FeMale";
                                            }
                                        }
                                        table.row.add([res.responseData[i].member_no,
                                            res.responseData[i].name + ' ' + res.responseData[i].surname,
                                            res.responseData[i].membertype_desc,
                                            sex,
                                            res.responseData[i].tel,
                                            res.responseData[i].email,
                                            status,
                                            res.responseData[i].update_date,
                                            res.responseData[i].update_user,
                                            res.responseData[i].member_no
                                        ]).draw();
                                    }
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterComponent.prototype.InitDropDown = function () {
        this.InitDropDownMemberType();
        this.InitDropDownPosition();
        this.InitDropDownDepartment();
    };
    RegisterComponent.prototype.InitDropDownMemberType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        data["lang"] = this.util.GetLanguage();
                        return [4 /*yield*/, this.apiService.post('util', 'GetMemberType', data)];
                    case 1:
                        res = _a.sent();
                        if (res != null) {
                            if (res.responseData != null) {
                                this.util.InitDropdownAll(res.responseData, 'ddlMemberType');
                                this.util.InitDropdown(res.responseData, 'ddlDlgMemberType');
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterComponent.prototype.InitDropDownPosition = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        data["lang"] = this.util.GetLanguage();
                        return [4 /*yield*/, this.apiService.post('util', 'GetPosition', data)];
                    case 1:
                        res = _a.sent();
                        if (res != null) {
                            if (res.responseData != null) {
                                this.util.InitDropdown(res.responseData, 'ddlDlgPosition');
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterComponent.prototype.InitDropDownDepartment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        data["lang"] = this.util.GetLanguage();
                        return [4 /*yield*/, this.apiService.post('util', 'GetDepartment', data)];
                    case 1:
                        res = _a.sent();
                        if (res != null) {
                            if (res.responseData != null) {
                                this.util.InitDropdown(res.responseData, 'ddlDlgDepartMent');
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterComponent.prototype.Add = function () {
        this.ClearDlg();
        $("#txtMode").val('A');
        $('#txtDlgID').prop('disabled', false);
        $('#dlgData').modal({
            backdrop: 'static',
            keyboard: false
        });
    };
    RegisterComponent.prototype.InitEdit = function (x) {
        this.obj_data = {};
        if (this.obj_data_all != null) {
            if (this.obj_data_all.length > 0) {
                for (var i = 0; i < this.obj_data_all.length; i++) {
                    if (x == this.obj_data_all[i].member_no) {
                        $('#txtDlgID').val(this.obj_data_all[i].member_no);
                        $('#ddlDlgMemberType').val(this.obj_data_all[i].member_type);
                        $('#txtDlgName').val(this.obj_data_all[i].name);
                        $('#txtDlgSurname').val(this.obj_data_all[i].surname);
                        $('#txtDlgTel').val(this.obj_data_all[i].tel);
                        $('#txtDlgEmail').val(this.obj_data_all[i].email);
                        $('#ddlDlgPosition').val(this.obj_data_all[i].position_code);
                        $('#ddlDlgDepartMent').val(this.obj_data_all[i].department_code);
                        $('#ddlDlgStatus').val(this.obj_data_all[i].status);
                        $('#txtDlgBirthDate').val(this.obj_data_all[i].birth_date);
                        $('#txtDlgExpireDate').val(this.obj_data_all[i].expire_date).change();
                        $('#ddlDlgSex').val(this.obj_data_all[i].sex);
                        this.obj_data = this.obj_data_all[i];
                        //  this.obj_memberkey_all = this.obj_data_all[i].listMemberKey;
                        // this.InitMemberkey();
                        break;
                    }
                }
            }
        }
    };
    RegisterComponent.prototype.InitMemberkey = function () {
        var table = $('#tDlgData').DataTable();
        table.clear().draw();
        if (this.obj_memberkey_all != null) {
            if (this.obj_memberkey_all.length > 0) {
                for (var i = 0; i < this.obj_memberkey_all.length; i++) {
                    table.row.add([this.obj_memberkey_all[i].member_key,
                        this.obj_memberkey_all[i].expire_date,
                        this.obj_memberkey_all[i].member_key
                    ]).draw();
                }
                var that = this;
                $('#tDlgData tbody').on('click', 'i', function () {
                    table.row($(this).parents('tr')).remove().draw(false);
                });
            }
        }
    };
    RegisterComponent.prototype.AddMemberKey = function () {
        var table = $('#tDlgData').DataTable();
        table.row.add(['',
            '',
            ''
        ]).draw();
        var that = this;
        $('#tDlgData tbody').on('click', 'i', function () {
            table.row($(this).parents('tr')).remove().draw(false);
        });
        /*
      var memberkey: any = {};
      memberkey['member_key'] = '';
      memberkey['expire_date'] = '';
      if (this.obj_memberkey_all == null) {
        this.obj_memberkey_all = [];
      }
      this.obj_memberkey_all.push(memberkey);
      this.InitMemberkey();*/
    };
    RegisterComponent.prototype.DeleteMemberKey = function (x) {
        if (this.obj_memberkey_all != null) {
            if (this.obj_memberkey_all.length > 0) {
                for (var i = 0; i < this.obj_memberkey_all.length; i++) {
                    if (this.obj_memberkey_all[i].member_key == x) {
                        this.obj_memberkey_all.splice(i, 1);
                        this.InitMemberkey();
                        break;
                    }
                }
            }
        }
    };
    RegisterComponent.prototype.Edit = function () {
        $("#txtMode").val('E');
        $('#txtDlgID').prop('disabled', true);
        if ($('#txtDlgID').val() != '' && $('#txtDlgID').val() != null
            && $('#txtDlgID').val() != 'null') {
            $('#dlgData').modal({
                backdrop: 'static',
                keyboard: false
            });
        }
        else {
            this.util.ErrorDialog('กรุณาเลือกรายการที่ต้องการแก้ไข');
        }
    };
    RegisterComponent.prototype.ClearDlg = function () {
        this.obj_data = {};
        $("#divCusError").hide();
        $('#txtDlgID').val('');
        $("select#ddlDlgMemberType")[0].selectedIndex = 0;
        $('#txtDlgName').val('');
        $('#txtDlgSurname').val('');
        $('#txtDlgTel').val('');
        $('#txtDlgEmail').val('');
        $('#txtDlgPassword').val('');
        $("select#ddlDlgPosition")[0].selectedIndex = 0;
        $("select#ddlDlgDepartMent")[0].selectedIndex = 0;
        $("select#ddlDlgStatus")[0].selectedIndex = 0;
        $('#txtDlgBirthDate').val('');
        $('#txtDlgExpireDate').val('');
        $('#ddlDlgSex').val('M');
        var table = $('#tDlgData').DataTable();
        table.clear().draw();
        this.obj_memberkey_all = null;
    };
    RegisterComponent.prototype.Save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var that, data, check, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.util.ValidateForm()) return [3 /*break*/, 3];
                        that = this;
                        data = {};
                        if ($("#txtMode").val() == 'A') {
                            data["MEMBER_NO"] = $('#txtDlgID').val();
                            data["PASSWORD"] = $('#txtDlgPassword').val();
                            data["MEMBER_TYPE"] = $('#ddlDlgMemberType').val();
                            data["NAME"] = $('#txtDlgName').val();
                            data["surname"] = $('#txtDlgSurname').val();
                            data["TEL"] = $('#txtDlgTel').val();
                            data["EMAIL"] = $('#txtDlgEmail').val();
                            data["POSITION_CODE"] = $('#ddlDlgPosition').val();
                            data["DEPARTMENT_CODE"] = $('#ddlDlgDepartMent').val();
                            data["STATUS"] = $('#ddlDlgStatus').val();
                            data["SEX"] = $('#ddlDlgSex').val();
                            data["UPDATE_USER"] = this.util.GetUserID();
                            data["BIRTH_DATE"] = $('#txtDlgBirthDate').val();
                            data["EXPIRE_DATE"] = $('#txtDlgExpireDate').val();
                        }
                        else {
                            data = this.obj_data;
                            data["PASSWORD"] = $('#txtDlgPassword').val();
                            data["MEMBER_TYPE"] = $('#ddlDlgMemberType').val();
                            data["NAME"] = $('#txtDlgName').val();
                            data["surname"] = $('#txtDlgSurname').val();
                            data["TEL"] = $('#txtDlgTel').val();
                            data["EMAIL"] = $('#txtDlgEmail').val();
                            data["POSITION_CODE"] = $('#ddlDlgPosition').val();
                            data["DEPARTMENT_CODE"] = $('#ddlDlgDepartMent').val();
                            data["STATUS"] = $('#ddlDlgStatus').val();
                            data["SEX"] = $('#ddlDlgSex').val();
                            data["UPDATE_USER"] = this.util.GetUserID();
                            data["BIRTH_DATE"] = $('#txtDlgBirthDate').val();
                            data["EXPIRE_DATE"] = $('#txtDlgExpireDate').val();
                        }
                        check = 0;
                        if (!(check == 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiService.post('member', 'InsertUpdateMember', data, $("#txtMode").val())];
                    case 1:
                        res = _a.sent();
                        if (res != null) {
                            if (res.isSuccess) {
                                this.util.SuccessDialog('บันทึกสำเร็จ');
                                $('#dlgData').modal('hide');
                                this.ClearDlg();
                                this.Search();
                            }
                            else {
                                this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
                            }
                        }
                        else {
                            this.util.ErrorDialog('System Error');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.util.ErrorDialog('กรอกค่าไม่ครบถ้วน');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RegisterComponent.prototype.DeleteMember = function (member_no) {
        return __awaiter(this, void 0, void 0, function () {
            var that, data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        data = {};
                        data["MEMBER_NO"] = member_no;
                        return [4 /*yield*/, this.apiService.post('member', 'DeleteMember', data)];
                    case 1:
                        res = _a.sent();
                        if (res != null) {
                            if (res.isSuccess) {
                                this.util.SuccessDialog('บันทึกสำเร็จ');
                                this.Search();
                            }
                            else {
                                this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
                            }
                        }
                        else {
                            this.util.ErrorDialog('System Error');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return RegisterComponent;
}());
export { RegisterComponent };



// WEBPACK FOOTER //
// ./src/app/member/register/register.component.ts.pre-build-optimizer.js